// extracted by mini-css-extract-plugin
module.exports = {"previewJumbotron":"PreviewJumbotron_previewJumbotron__1LVGk","blankImage":"PreviewJumbotron_blankImage__1cV2m"};